import React from 'react';
import './index.scss';

export default function FooterLayout() {
  return (
    <div className="footer-container">
      <a href="https://salesstack.ai/terms" target="_blank" rel="noopener noreferrer" className="text-left">
        TERMS AND CONDITIONS
      </a>
      <a href="https://salesstack.ai/privacy" target="_blank" rel="noopener noreferrer" className="text-center">
        PRIVACY POLICY
      </a>
      <a href="mailto:contact@salesstack.ai" target="_blank" rel="noopener noreferrer" className="text-right">
        CONTACT
      </a>
    </div>
  );
}
